export default (el) => ({
  id: String(el.WebID),
  name: String(el.MeterDisplayName),
  label: String(el.MeterId),
  previous: String(el.BackMeterDec),
  current: String(el.CurrentMeterDec > 0 ? el.CurrentMeterDec : ''),
  scale: Number(el.Unit),
  date: new Date(Number((el.LastDate || '').replace(/\D/gi, ''))),
  accountId: Number(el.SubscrId),
  accountCode: String(el.SubscrCode),
  isComplete() {
    return Number(this.current) >= Number(this.previous);
  },
  getPayload() {
    return {
      subscrId: this.accountCode,
      meterId: this.id,
      reading: this.current,
    };
  },
});
